module.exports = __webpack_public_path__ + "static/media/AW.07dd0e3d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/AW.svg
// module id = 195
// module chunks = 0